/**
 * Session Validation Client Data Utility
 * Collects data that can ONLY be obtained client-side
 * Note: User-Agent, Referer, Browser, OS, DeviceType, and IsBot are all handled server-side
 */

/**
 * Check if JavaScript is properly executed
 * This should always return true in a real browser
 * @returns {boolean} True if JS is executed
 */
export const checkJsExecuted = () => {
	return true; // If this code runs, JS is executed
};

/**
 * Check if the window/tab has focus
 * @returns {boolean} True if window has focus
 */
export const checkHasFocus = () => {
	return document.hasFocus();
};

/**
 * Get screen resolution (only available client-side)
 * @returns {string} Screen resolution in format "widthxheight"
 */
export const getScreenResolution = () => {
	const width = window.screen.width;
	const height = window.screen.height;
	return `${width}x${height}`;
};

/**
 * Get client-side session validation data
 * Returns ONLY data that cannot be obtained server-side
 *
 * Note: The following are handled server-side and should NOT be sent from client:
 * - User-Agent, Referer (from HTTP headers)
 * - Browser, OS, DeviceType (parsed from User-Agent)
 * - IsBot (detected from User-Agent patterns)
 * - Country, City (from GeoIP lookup)
 *
 * @returns {Object} Client-side session data
 * @property {boolean} jsexecuted - Proof that JavaScript is executing (always true if called)
 * @property {boolean} hasfocus - Whether the browser window/tab has focus
 * @property {string} screenresolution - Screen resolution in format "widthxheight"
 */
export const getSessionClientData = () => {
	return {
		screenresolution: getScreenResolution(),
		jsexecuted: checkJsExecuted(),
		hasfocus: checkHasFocus(),
	};
};

/**
 * Legacy function name for backward compatibility
 * @deprecated Use getSessionClientData() instead
 */
export const getBotDetectionData = () => {
	return getSessionClientData();
};
